import APIService from 'src/services/APIService'

const api = APIService()

export const contactFormPost = payload => api.post('/contact-form', payload)
